export default __webpack_public_path__ + "static/media/Sai_Dham@2x.7b3d72ea.png";